import { memo } from "react";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import ProductGallery from "./ProductGallery";
import { getCatalogDiscountedPrice, getCatalogRegularPrice, } from "../utils/catalogUtils";

const CatalogProductCard = memo(({ product, isAuthenticated, onNavigate, buildPath, buildState }) => (
  <article className={`catalog-card ${product.descuento > 0 && isAuthenticated ? "catalog-card-discounted" : ""}`}>
    <div className="catalog-card-media">
      {product.descuento > 0 && isAuthenticated ? (
        <Tag
          value="OFERTA"
          icon="pi pi-bolt"
          severity="success"
          className="catalog-card-discount-badge"
        />
      ) : null}

      <ProductGallery
        fotos={product.fotos}
        image={product.image}
        alt={product.descripcion}
        className="catalog-card-carousel"
      />
    </div>
    <div className="catalog-card-content">
      <div className="catalog-card-body">
        <span className="catalog-card-type p-text-secondary">{product.tipo}</span>
        <h3 className="p-font-bold">{product.descripcion}</h3>
      </div>
      {isAuthenticated && (
        <div className="catalog-card-details">
          <div className={`catalog-card-price-row ${product.descuento > 0 ? "has-discount" : ""}`}>
            <span className="catalog-card-price">{getCatalogDiscountedPrice(product.precio, product.descuento)}</span>
            {product.descuento > 0 ? <Tag value={`-${product.descuento}%`} severity="success" className="catalog-card-discount-tag" /> : null}
          </div>
          {getCatalogRegularPrice(product.precio, product.descuento) ? (
            <span className="catalog-card-regular-price p-text-line-through">Normal {getCatalogRegularPrice(product.precio, product.descuento)}</span>
          ) : null}
        </div>
      )}
      <div className={`catalog-card-footer ${product.descuento > 0 && isAuthenticated ? "catalog-card-discounted" : ""}`}>
        <Button
          label={product.stock > 0 ? "Ver Producto" : "Cotizar"}
          className="catalog-card-cta p-button-sm"
          onClick={() => onNavigate("/catalogo/detalle" + buildPath(product), { state: buildState(product) })}
        />
      </div>
    </div>
  </article>
));

export default CatalogProductCard;